module.exports = __webpack_public_path__ + "static/media/whisky_thumb_1.f0793943.jpg";